
import { PipeTransform, Pipe } from '@angular/core';
import { compareTwoStrings, findBestMatch } from 'string-similarity';

@Pipe({
    name: 'personFilter',
    pure: false
})
export class PersonFilterPipe implements PipeTransform {

    phonemes(text) {
        return text.toLowerCase().normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "").replaceAll('k', 'c').replaceAll('z', 's').replaceAll('w', 'v').replaceAll('y', 'i').replaceAll('ph', 'f').replaceAll('ch', 'x').replaceAll('\'', '').replaceAll('&', 'e').replaceAll(' ', '').replaceAll('.', '').replaceAll('cc', 'c').replaceAll('ll', 'l').replaceAll('+', 'mais');
    }
    transform(items: any[], value: any, field = 'title'): any {
        if (!items || !value || !items?.length) {
            return [];
        }
        value = this.phonemes(value);
        // filter items array, items which match and return true will be
        // kept, false will be filtered out 

        let r = items?.filter(item => {
            const text = this.phonemes(item[field]);
            const name = item?.name ? this.phonemes(item?.name) : "";

            return !item?.noFilter &&
                (!item?.type || item?.type == 'item') &&
                (
                    compareTwoStrings(item[field], value) >= 0.3 ||
                    (name && compareTwoStrings(name, value) >= 0.3) ||
                    text.indexOf(value) > - 1 ||
                    name?.indexOf(value) > - 1
                )
        });
        return r;
    }
}